import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "layouts/auth";
import "assets/css/Plugins.css";
import { useState, useEffect } from "react";
import { AuthProvider, useAuthContext } from "auth/AuthProvider";
import ProtectedRoute from "auth/ProtectedRoute";
import { ConfirmationProvider } from "components/dialog/confirmation";
import DashboardLayout from "layouts/dashboard";
import { Toaster } from "react-hot-toast";
import { SidebarCountsProvider } from "contexts/SidebarCountsContext";
import { NotificationProvider } from "contexts/NotificationContext";
import Assistant from "layouts/assistant";
import { OnBoardingProvider } from "./auth/OnBoardingProvider";
import Loader from "components/Loader";
import "./i18n/config";
import { useTranslation } from "react-i18next";

const DefaultRedirect = () => {
  const { isLoading, hasFullControl } = useAuthContext();
  const { t } = useTranslation();
  
  if (isLoading) {
    return <Loader txt={t("common.loading")} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />;
  }
  
  const isFullControl = hasFullControl();
  return <Navigate to={isFullControl ? "/dashboard" : "/chat"} replace />;
};

const App = () => {
  // Create a new context
  const [themeApp, setThemeApp] = useState<any>({
    "--background-100": "#FFFFFF",
    "--background-900": "#070f2e",
    "--shadow-100": "rgba(112, 144, 176, 0.08)",
    "--color-50": "#E9E3FF",
    "--color-100": "#C0B8FE",
    "--color-200": "#A195FD",
    "--color-300": "#8171FC",
    "--color-400": "#7551FF",
    "--color-500": "#422AFB",
    "--color-600": "#3311DB",
    "--color-700": "#2111A5",
    "--color-800": "#190793",
    "--color-900": "#11047A",
  });
  const [mini, setMini] = useState(false);

  // When the theme state changes, this effect will update the CSS variables in the document's root element
  useEffect(() => {
    let color;
    for (color in themeApp) {
      document.documentElement.style.setProperty(color, themeApp[color]);
    }
    //eslint-disable-next-line
  }, [themeApp]);
  return (
    <>
      <OnBoardingProvider>
        <AuthProvider>
          <SidebarCountsProvider>
            <ConfirmationProvider>
              <Routes>
                <Route path="auth/*" element={<AuthLayout />} />
                <Route
                  path="dashboard/*"
                  element={
                    <ProtectedRoute>
                    <NotificationProvider>
                        <DashboardLayout
                          setMini={setMini}
                          mini={mini}
                          theme={themeApp}
                          setTheme={setThemeApp}
                        />
                    </NotificationProvider>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="chat/*"
                  element={
                    <ProtectedRoute>
                      <Assistant />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<DefaultRedirect />} />
              </Routes>
            </ConfirmationProvider>
          </SidebarCountsProvider>
        </AuthProvider>
      </OnBoardingProvider>
      <Toaster toastOptions={{ duration: 1000 }} />
    </>
  );
};

export default App;
